var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.599609C8.98216 0.599821 11.3994 3.01779 11.3994 6C11.3992 8.98203 8.98203 11.3992 6 11.3994C3.01779 11.3994 0.599821 8.98216 0.599609 6C0.599609 3.01766 3.01766 0.599609 6 0.599609ZM5.34961 6.6875L4.12988 5.46875L3.06934 6.5293L5.4502 8.91016L5.97559 8.2793L8.97559 4.67969L7.82324 3.71875L5.34961 6.6875Z",
    fill: "#4CB55C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.bdfa5f020f2032ca9cfc19574cce3abd.svg";
export { ForwardRef as ReactComponent };